/* eslint no-console: 0 */
import React from 'react';
import { useParams } from 'react-router-dom';
import { useSetModalTitle } from '../../../hooks/modal/useSetModalTitle.ts';
import { useGetDevice } from '../../../hooks/useGetDevice.ts';
import Loading from '../Loading.jsx';
import DeviceInfoSection from './DeviceInfoSection.jsx';
import DeviceOptionsSection from './DeviceOptionsSection.jsx';

interface DeviceOverviewProps {}

/**
 * Component that lists devices belonging to the user.
 */
export const DeviceOverview: React.FC<DeviceOverviewProps> = () => {
  const { id: deviceId } = useParams();
  const { data: device, isFetching } = useGetDevice({ deviceId });

  // Show loading indicator if we're fetching content AND have nothing to display. This means
  // refreshes will not show loading. Important because of the query invalidation that can happen
  // (we want query invalidation to show loading)
  const isLoading = isFetching && !device;

  useSetModalTitle('Device Overview');

  return (
    <>
      {isLoading && <Loading />}

      {!isLoading && <>
        <DeviceInfoSection device={device} />
        <DeviceOptionsSection device={device} />
      </>}
    </>
  );
};
